// App.js
import React, { useEffect, useState } from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import {
  Text,
  View,
  StyleSheet,
  ActivityIndicator,
  useWindowDimensions, // ✅ add
} from 'react-native';

// ⬇️ Your screens
import BusinessHomepage from './BusinessHomepage';
import CreateBrandListing from './CreateBrandListing';
import CreateBrandListingChoice from './CreateBrandListingChoice';
import QRCodeScannerPage from './QRCodeScannerPage';
import PotentialCollabsDashboard from './PotentialCollabsDashboard';
import ReviewCollabOfferForm from './ReviewCollabOfferForm';
import PostScanAdminRedeem from './PostScanAdminRedeem';
import SignUpPage from './SignUpPage';
import LogInPage from './LogInPage';
import BusinessAccountPage from './BusinessAccountPage';
import BrandListingsDashboard from './BrandListingsDashboard';
import ListingAssociatedCollabsDashboard from './ListingAssociatedCollabsDashboard';
import SingleCollabMetrics from './SingleCollabMetrics';
import TestQRCodeScannerPage from './TestQRCodeScannerPage';
import PasswordResetForm from './PasswordResetForm';
import SubmitChangedPassword from './SubmitChangedPassword';
import PostScanAdminRedeemCustomer from './PostScanAdminRedeemCustomer';
import PaymentPage from './PaymentPage';
import CollabCalendar from './CollabCalendar';
import collabbayAnalytics from './collabbayAnalytics';
import CampaignMetrics from './CampaignMetrics';
import InfluencerProfileAnalysis from './InfluencerProfileAnalysis';
import BrandCreateInviteLink from './BrandCreateInviteLink';
import EditOfferListing from './EditOfferListing';
import BrandActivityFeed from './BrandActivityFeed';
import InviteCollabbayCreator from './InviteCollabbayCreator';
import BrowseInviteCreators from './BrowseInviteCreators';
import GuidedOfferSetup from './GuidedOfferSetup';
import PostSuggestedListing from './PostSuggestedListing';
import MyPanel from './MyPanel';
import WelcomeOptions from './WelcomeOptions';
import ReviewDashboard from './ReviewDashboard';
import CreatorPreview from './CreatorPreview';
import BookingRequest from './BookingRequest';
import RequestList from './RequestList';
import MyOffers from './MyOffers';
import CreatorOverview from './CreatorOverview';
import MyCalendar from './MyCalendar';
import BrowseCreators from './BrowseCreators';
import InviteCreator from './InviteCreator';
import MyActivityFeed from './MyActivityFeed';
import MyReviews from './MyReviews';

// ✅ NEW screen (EditMyListing)
import EditMyListing from './EditMyListing';

// ✅ Existing public screen
import PreviewBooking from './PreviewBooking';


import ContentBank from './ContentBank';

import BrandAIAnalysis from './BrandAIAnalysis';
import PublicBookingsAnalyticsDashboard from './PublicBookingsAnalyticsDashboard';

import AssignVouchers from './AssignVouchers';


const Stack = createStackNavigator();

// Optional flash message (not used right now but kept)
const FlashMessage = ({ message }) => (
  <View style={styles.flashMessageContainer}>
    <Text style={styles.flashMessageText}>{message}</Text>
  </View>
);

/**
 * 🔗 Linking config:
 * This is what makes /BookingRequest/123 → BookingRequest screen with { CollabID: "123" }
 */
const linking = {
  // URLs your app should handle
  prefixes: [
    'https://collabbayadmin.com',
    'https://www.collabbayadmin.com',
    'http://localhost:19006', // dev
  ],
  config: {
    screens: {
      // Root/home
      BusinessHomepage: '',

      // Auth
      SignUpPage: 'register',
      LogInPage: 'login',
      PasswordResetForm: 'PasswordReset',
      SubmitChangedPassword: 'ResetPassword/:token',

      BusinessAccountPage: 'account',

      // ✅ Public: Preview Booking (supports query params like ?CollabID=123&Promoter=abc)
      PreviewBooking: 'PreviewBooking',

      // ✅ NEW: EditMyListing (supports query params like ?ListingID=123)
      EditMyListing: 'EditMyListing',

      // Booking / collab screens
      BookingRequest: 'BookingRequest/:CollabID',
      RequestList: 'RequestList',
      CollabCalendar: 'CollabCalendar',
      MyCalendar: 'MyCalendar',

      // Listings / offers
      BrandListingsDashboard: 'BrandListingsDashboard',
      CreateBrandListing: 'CreateBrandListing',
      CreateBrandListingChoice: 'CreateBrandListingChoice',
      EditOfferListing: 'EditOfferListing/:ListingID?',
      MyOffers: 'MyOffers',

      // QR / Redeem flows
      QRCodeScannerPage: 'QRCodeScannerPage',
      PostScanAdminRedeem: 'PostScanAdminRedeem/:QRID',
      PostScanAdminRedeemCustomer: 'PostScanAdminRedeemCustomer/:CollabID',

      // Analytics / metrics
      collabbayAnalytics: 'Analytics',
      CampaignMetrics: 'CampaignMetrics',
      SingleCollabMetrics: 'SingleCollabMetrics/:CollabID?',
      InfluencerProfileAnalysis: 'InfluencerProfileAnalysis/:Username?',

      // Invites & creators
      BrowseInviteCreators: 'BrowseInviteCreators',
      InviteCollabbayCreator: 'InviteCollabbayCreator/:Username',
      BrowseCreators: 'BrowseCreators',
      InviteCreator: 'InviteCreator/:Username?',
      CreatorOverview: 'CreatorOverview/:Username?',
      CreatorPreview: 'CreatorPreview/:Username?',

      // Other dashboards / flows
      PotentialCollabsDashboard: 'PotentialCollabsDashboard',
      ReviewCollabOfferForm: 'ReviewCollabOfferForm/:CollabID?',
      PaymentPage: 'subscribe',
      BrandCreateInviteLink: 'BrandCreateInviteLink',
      BrandActivityFeed: 'BrandActivityFeed',
      MyActivityFeed: 'MyActivityFeed',
      MyReviews: 'MyReviews',
      TestQRCodeScannerPage: 'TestQRCodeScannerPage',
      GuidedOfferSetup: 'GuidedOfferSetup',
      PostSuggestedListing: 'PostSuggestedListing',
      MyPanel: 'MyPanel',
      WelcomeOptions: 'WelcomeOptions',
      ReviewDashboard: 'ReviewDashboard',
      ListingAssociatedCollabsDashboard:'ListingAssociatedCollabsDashboard/:ListingID?',
        ContentBank: 'ContentBank',
        BrandAIAnalysis: 'BrandAIAnalysis',
        PublicBookingsAnalyticsDashboard: 'PublicBookingsAnalyticsDashboard',
        AssignVouchers: 'AssignVouchers',


    },
  },
};

const AppContent = ({ authenticated, subscriptionAuthenticated }) => {
  // ✅ Responsive default homepage: desktop (>650px) shows MyPanel, mobile keeps BusinessHomepage
  const ResponsiveHomepage = (props) => {
    const { width } = useWindowDimensions();

    // If desktop AND authenticated, show MyPanel as the "/" landing view
    if (width > 650 && authenticated) {
      return <MyPanel {...props} />;
    }

    // Otherwise keep existing behaviour
    return <BusinessHomepage {...props} />;
  };

  return (
    <NavigationContainer
      linking={linking}
      fallback={
        <View style={styles.loadingContainer}>
          <ActivityIndicator size="large" color="#000" />
        </View>
      }
    >
      <Stack.Navigator
        initialRouteName="BusinessHomepage"
        screenOptions={{ headerShown: false }}
      >
        {/* Public screens */}
        <Stack.Screen
          name="BusinessHomepage"
          component={ResponsiveHomepage} // ✅ changed ONLY this
        />
        <Stack.Screen name="SignUpPage" component={SignUpPage} />
        <Stack.Screen name="LogInPage" component={LogInPage} />
        <Stack.Screen name="PasswordResetForm" component={PasswordResetForm} />
        <Stack.Screen
          name="SubmitChangedPassword"
          component={SubmitChangedPassword}
        />
        <Stack.Screen
          name="BusinessAccountPage"
          component={BusinessAccountPage}
        />

        {/* ✅ Public screen */}
        <Stack.Screen name="PreviewBooking" component={PreviewBooking} />

        {/* ✅ NEW: EditMyListing screen */}
        <Stack.Screen name="EditMyListing" component={EditMyListing} />

        {/* Authenticated-only screens */}
        {authenticated && (
          <>
            <Stack.Screen name="CollabCalendar" component={CollabCalendar} />
            <Stack.Screen
              name="QRCodeScannerPage"
              component={QRCodeScannerPage}
            />
            <Stack.Screen
              name="BrandListingsDashboard"
              component={BrandListingsDashboard}
            />
            <Stack.Screen
              name="ListingAssociatedCollabsDashboard"
              component={ListingAssociatedCollabsDashboard}
            />
            <Stack.Screen
              name="SingleCollabMetrics"
              component={SingleCollabMetrics}
            />
            <Stack.Screen
              name="TestQRCodeScannerPage"
              component={TestQRCodeScannerPage}
            />
            <Stack.Screen
              name="CreateBrandListing"
              component={CreateBrandListing}
            />
            <Stack.Screen
              name="CreateBrandListingChoice"
              component={CreateBrandListingChoice}
            />
            <Stack.Screen
              name="PotentialCollabsDashboard"
              component={PotentialCollabsDashboard}
            />
            <Stack.Screen
              name="ReviewCollabOfferForm"
              component={ReviewCollabOfferForm}
            />
            <Stack.Screen
              name="PostScanAdminRedeem"
              component={PostScanAdminRedeem}
            />
            <Stack.Screen
              name="PostScanAdminRedeemCustomer"
              component={PostScanAdminRedeemCustomer}
            />
            <Stack.Screen name="PaymentPage" component={PaymentPage} />
            <Stack.Screen
              name="collabbayAnalytics"
              component={collabbayAnalytics}
            />  
           <Stack.Screen name
           ="AssignVouchers" component={AssignVouchers} 
           />
            <Stack.Screen
              name="CampaignMetrics"
              component={CampaignMetrics}
            />
            <Stack.Screen
              name="InfluencerProfileAnalysis"
              component={InfluencerProfileAnalysis}
            />
            <Stack.Screen
              name="BrandCreateInviteLink"
              component={BrandCreateInviteLink}
            />
            <Stack.Screen
              name="EditOfferListing"
              component={EditOfferListing}
            />
            <Stack.Screen
              name="BrandActivityFeed"
              component={BrandActivityFeed}
            />
            <Stack.Screen name="MyActivityFeed" component={MyActivityFeed} />
            <Stack.Screen name="MyReviews" component={MyReviews} />
            <Stack.Screen
              name="BrowseInviteCreators"
              component={BrowseInviteCreators}
            />
            <Stack.Screen
              name="InviteCollabbayCreator"
              component={InviteCollabbayCreator}
            />
            <Stack.Screen
              name="GuidedOfferSetup"
              component={GuidedOfferSetup}
            />
            <Stack.Screen
  name="PostSuggestedListing"
  component={PostSuggestedListing}
/>
            <Stack.Screen name="MyPanel" component={MyPanel} />
            <Stack.Screen name="WelcomeOptions" component={WelcomeOptions} />
            <Stack.Screen name="ReviewDashboard" component={ReviewDashboard} />
            <Stack.Screen name="CreatorPreview" component={CreatorPreview} />
<Stack.Screen
  name="BookingRequest"
  component={BookingRequest}
  getId={({ params }) =>
    params?.CollabID ? `BookingRequest-${params.CollabID}` : undefined
  }
/>
            <Stack.Screen name="RequestList" component={RequestList} />
            <Stack.Screen name="MyOffers" component={MyOffers} />
            <Stack.Screen name="CreatorOverview" component={CreatorOverview} />
            <Stack.Screen name="MyCalendar" component={MyCalendar} />
            <Stack.Screen name="BrowseCreators" component={BrowseCreators} />
            <Stack.Screen name="InviteCreator" component={InviteCreator} />

<Stack.Screen name="ContentBank" component={ContentBank} />

<Stack.Screen name="BrandAIAnalysis" component={BrandAIAnalysis} />

<Stack.Screen
  name="PublicBookingsAnalyticsDashboard"
  component={PublicBookingsAnalyticsDashboard}
/>

          </>
        )}
      </Stack.Navigator>
    </NavigationContainer>
  );
};

const App = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [subscriptionAuthenticated, setSubscriptionAuthenticated] =
    useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true); // loading state

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        await checkAuthentication();
        await checkSubscriptionAuthentication();
      } catch (err) {
        console.error('Error during loading:', err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const checkAuthentication = async () => {
    try {
      const response = await fetch(
        'https://collabbayadmin.com/APIControllers/UserAuthSession.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await response.json();
      if (data.authenticated) {
        setAuthenticated(true);
      } else {
        setAuthenticated(false);
        setError('Log in required');
      }
    } catch (error) {
      console.error('Error checking authentication:', error);
      setError('An error occurred. Please try again later.');
    }
  };

  const checkSubscriptionAuthentication = async () => {
    try {
      const response = await fetch(
        'https://collabbayadmin.com/APIControllers/UserSubscriptionAuth.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      const subscriptionData = await response.json();
      setSubscriptionAuthenticated(subscriptionData.authenticated);
    } catch (error) {
      console.error('Error checking subscription authentication:', error);
      setError('An error occurred while checking subscription.');
    }
  };

  if (loading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#000" />
      </View>
    );
  }

  return (
    <AppContent
      authenticated={authenticated}
      subscriptionAuthenticated={subscriptionAuthenticated}
    />
  );
};

const styles = StyleSheet.create({
  flashMessageContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'yellow',
    padding: 10,
  },
  flashMessageText: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
  },
});

export default App;
